module.exports = __webpack_public_path__ + "media/success.902c7d1a.wav";